import script from "./BenefitsCalculatorLandingPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./BenefitsCalculatorLandingPage.vue?vue&type=script&setup=true&lang=ts"

import "./BenefitsCalculatorLandingPage.vue?vue&type=style&index=0&id=e3428f66&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e3428f66"]])

export default __exports__